// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"LoadingBox_loadingBox_2Ionk","loading":"LoadingBox_loading_pKuQn","light":"LoadingBox_light_1CYt9","tips":"LoadingBox_tips_ph59U"};